import { equals } from 'ramda'
import * as zod from 'zod'
import { CompanyTypeValue } from 'api/companies/companyType'

const companyType: zod.ZodType<CompanyTypeValue> = zod.enum([
  '1099',
  'w2',
  'w2_everify',
])

export const editGeneralDetailsFlowSchema = zod
  .object({
    type: companyType,
    terminalTierThresholdHours: zod.coerce
      .number()
      .min(0, 'Must be at least 0'),
    terminalTierThresholdDirection: zod
      .enum(['after_shift_create', 'before_shift_start'])
      .default('before_shift_start'),
    pastShiftCreationAllowed: zod.boolean(),
    // Used to check if the values have changed
    currentValues: zod.object({
      type: companyType,
      terminalTierThresholdHours: zod.number(),
      terminalTierThresholdDirection: zod.enum([
        'after_shift_create',
        'before_shift_start',
      ]),
      pastShiftCreationAllowed: zod.boolean(),
    }),
  })
  .superRefine((data, ctx) => {
    const haveAnyFieldsChanged = Object.keys(data.currentValues).some((key) => {
      const areEquals = equals(data[key], data.currentValues[key])
      return !areEquals
    })

    if (!haveAnyFieldsChanged) {
      ctx.addIssue({
        code: zod.ZodIssueCode.custom,
        message:
          'No changes detected. Please modify at least one field to save.',
        path: ['currentValues'],
      })
    }
  })

export type EditGeneralDetailsFlowSchema = zod.infer<
  typeof editGeneralDetailsFlowSchema
>
